import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function SeleccionTipo() {
  const { usuario, logout } = useAuth();
  const navigate = useNavigate();

  const puedeAcceder = (tipo) => {
    if (!usuario) return false;
    if (['admin', 'profesor'].includes(usuario.rol)) return true;
    return (usuario.accesos || []).some(a => a.tipo === tipo);
  };

  const irA = (tipo) => {
    if (!puedeAcceder(tipo)) return;
    const nivelesAccesibles = (usuario.accesos || []).filter(a => a.tipo === tipo).map(a => a.nivel);
    const primerNivel = nivelesAccesibles[0] || (tipo === 'militar' ? 'SLP2' : 'B1');
    navigate(`/${tipo}/${primerNivel}/temario`);
  };

  const cards = [
    {
      tipo: 'militar',
      icono: '🎖️',
      titulo: 'Inglés Militar',
      subtitulo: 'SLP',
      niveles: 'SLP 2 · SLP 3 · SLP 4 · Acceso Suboficial · Acceso Oficial · Curso Suboficial · Curso Oficial',
      descripcion: 'Preparación específica para el ámbito militar, exámenes y certificaciones de defensa.',
      cardBg: 'linear-gradient(135deg, #FFB3C6 0%, #FF6B9D 100%)',
      borderColor: '#FF6B9D',
      levelBg: 'rgba(100,10,40,0.15)',
      colorTitulo: '#3D0018',
      colorSubtitulo: '#8B0038',
      colorNiveles: '#7A0030',
      colorDesc: '#8B0038',
    },
    {
      tipo: 'civil',
      icono: '🎓',
      titulo: 'Inglés Civil',
      subtitulo: 'Cambridge',
      niveles: 'B1 · B2 · C1 · C2',
      descripcion: 'Preparación para certificaciones Cambridge y mejora del inglés profesional y académico.',
      cardBg: 'linear-gradient(135deg, #EDE9FE 0%, #DDD6FE 100%)',
      borderColor: '#C4B5FD',
      levelBg: 'rgba(109,40,217,0.12)',
      colorTitulo: '#2E1065',
      colorSubtitulo: '#6D28D9',
      colorNiveles: '#5B21B6',
      colorDesc: '#6D28D9',
    },
  ];

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(160deg, #FCE7F3 0%, #F9A8D4 60%, #FBCFE8 100%)',
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      padding: '32px 24px',
      position: 'relative', overflow: 'hidden',
    }}>
      <div style={{
        position: 'absolute', inset: 0,
        backgroundImage: 'url(/united.png)',
        backgroundSize: 'cover', backgroundPosition: 'center',
        opacity: 0.12,
        filter: 'grayscale(100%) sepia(100%) hue-rotate(290deg) saturate(3) brightness(1.8)',
        pointerEvents: 'none',
      }} />
      <div className="fade-in" style={{ width: '100%', maxWidth: '900px', position: 'relative', zIndex: 1, isolation: 'isolate' }}>
        <div style={{ textAlign: 'center', marginBottom: '48px' }}>
<h1 style={{ fontSize: 'clamp(28px, 6vw, 54px)', color: '#581C47', marginBottom: '8px', fontWeight: 800 }}>
            Bienvenida/o, {usuario?.nombre?.split(' ')[0]}
          </h1>
          <p className="float" style={{ color: '#7B1450', fontSize: '18px', fontWeight: 600, letterSpacing: '0.5px' }}>Selecciona tu programa de estudios</p>
        </div>

        <div style={{
          display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: '24px', marginBottom: '40px',
        }}>
          {cards.map(c => {
            const acceso = puedeAcceder(c.tipo);
            return (
              <div
                key={c.tipo}
                onClick={() => irA(c.tipo)}
                style={{
                  background: acceso ? c.cardBg : 'linear-gradient(135deg, #FFF0F5 0%, #FDF2F8 100%)',
                  border: `2px solid ${acceso ? c.borderColor : '#FBCFE8'}`,
                  borderRadius: '20px', padding: '40px 36px',
                  cursor: acceso ? 'pointer' : 'not-allowed',
                  opacity: acceso ? 1 : 0.4,
                  transition: 'all 0.2s',
                  boxShadow: '0 4px 24px rgba(236,72,153,0.10)',
                  display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center',
                }}
                onMouseEnter={e => { if (acceso) { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.borderColor = '#EC4899'; e.currentTarget.style.boxShadow = '0 12px 36px rgba(236,72,153,0.20)'; }}}
                onMouseLeave={e => { if (acceso) { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.borderColor = c.borderColor; e.currentTarget.style.boxShadow = '0 4px 24px rgba(236,72,153,0.10)'; }}}
              >
                <h2 style={{ fontSize: '26px', color: c.colorTitulo, marginBottom: '6px', fontWeight: 800 }}>{c.titulo}</h2>
                <p style={{ color: c.colorSubtitulo, fontSize: '13px', marginBottom: '20px', fontFamily: 'Inter, sans-serif', fontWeight: 600, letterSpacing: '0.5px' }}>
                  {c.subtitulo}
                </p>
                <div style={{
                  background: c.levelBg, borderRadius: '10px',
                  padding: '10px 20px', marginBottom: '20px', fontSize: '14px',
                  color: c.colorNiveles, letterSpacing: '1px', fontWeight: 500, width: '100%',
                }}>
                  {c.niveles}
                </div>
                <p style={{ color: c.colorDesc, fontSize: '13px', lineHeight: '1.6', maxWidth: '280px' }}>
                  {c.descripcion}
                </p>
                {!acceso && (
                  <p style={{ color: '#F87171', fontSize: '12px', marginTop: '12px' }}>
                    No tienes acceso a esta sección
                  </p>
                )}
              </div>
            );
          })}
        </div>

        {(usuario?.rol === 'admin' || usuario?.rol === 'profesor') && (
          <div style={{ textAlign: 'center', marginBottom: '16px', display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
            {usuario?.rol === 'admin' && (
              <button onClick={() => navigate('/admin')}
                style={{ background: 'linear-gradient(135deg, #EC4899 0%, #F472B6 100%)', border: 'none', color: '#fff', padding: '10px 24px', borderRadius: '50px', fontSize: '14px', cursor: 'pointer', fontWeight: 700, boxShadow: '0 4px 14px rgba(236,72,153,0.35)', letterSpacing: '0.3px', display: 'inline-flex', alignItems: 'center', gap: '6px' }}
                onMouseEnter={e => e.currentTarget.style.boxShadow = '0 6px 20px rgba(236,72,153,0.5)'}
                onMouseLeave={e => e.currentTarget.style.boxShadow = '0 4px 14px rgba(236,72,153,0.35)'}>
                ⚙️ Panel Admin
              </button>
            )}
            <button onClick={() => navigate('/profesor')}
              style={{ background: 'linear-gradient(135deg, #7C3AED 0%, #A78BFA 100%)', border: 'none', color: '#fff', padding: '10px 24px', borderRadius: '50px', fontSize: '14px', cursor: 'pointer', fontWeight: 700, boxShadow: '0 4px 14px rgba(124,58,237,0.35)', letterSpacing: '0.3px', display: 'inline-flex', alignItems: 'center', gap: '6px' }}
              onMouseEnter={e => e.currentTarget.style.boxShadow = '0 6px 20px rgba(124,58,237,0.5)'}
              onMouseLeave={e => e.currentTarget.style.boxShadow = '0 4px 14px rgba(124,58,237,0.35)'}>
              🏫 Panel Profesor
            </button>
          </div>
        )}

        <div style={{ textAlign: 'center' }}>
          <button
            onClick={logout}
            style={{
              background: 'linear-gradient(135deg, #EC4899 0%, #F472B6 100%)',
              border: 'none', color: '#fff',
              fontSize: '14px', fontWeight: 600, cursor: 'pointer',
              padding: '10px 28px', borderRadius: '50px',
              boxShadow: '0 4px 16px rgba(236,72,153,0.35)',
              letterSpacing: '0.5px',
            }}
          >
            Cerrar sesión
          </button>
        </div>
      </div>
    </div>
  );
}
